import {FC, useEffect, useState} from 'react'
import classnames from 'classnames'
import {Rnd} from 'react-rnd'
import ActionButton from 'jbc-front/components/ActionButton'
import {Close, Visibility} from 'jbc-front/components/icons'
import {useMediaQuery} from 'hooks/useMediaQuery'
import {PdfPreview} from './PdfPreview'
import styles from './FilePreview.scss'
import {fileFormFormat} from 'libs/formatter'

type FilePreviewProps = {
  file: {
    name?: string
    url?: string
    preview?: string
    filename?: string
  } | null
}

const rndDefault = {
  x: -400,
  y: -500,
  width: 500,
  height: '70vh',
}

export const FilePreview: FC<FilePreviewProps> = ({file}) => {
  const [open, setOpen] = useState(false)
  const [fileUrl, setFileUrl] = useState<string | null>(null)
  const mq = useMediaQuery()

  useEffect(() => {
    if (file instanceof File) {
      const url = URL.createObjectURL(file)
      setFileUrl(url)
      return () => URL.revokeObjectURL(url)
    } else if (file) {
      setFileUrl(fileFormFormat(file)?.url || null)
      return
    } else {
      setFileUrl(null)
      return
    }
  }, [file])

  if (!fileUrl) {
    return null
  }

  const name = file?.name || file?.filename
  const fileExt = name ? name.split('.').pop() : null

  const toggleOpen = () => {
    setOpen(!open)
  }

  const renderPreview = () => {
    if (fileExt === 'pdf') {
      return mq.isPc ? (
        <object
          className={classnames(styles.preview, 'cancel')}
          data={fileUrl}
          title={'プレビュー'}
          type="application/pdf"
        >
          {'プレビュー'}
        </object>
      ) : (
        <PdfPreview file={fileUrl} />
      )
    } else if (fileExt === 'heic') {
      return <p className="m-title-main-note u-mb20">HEIC形式のファイルはプレビューできません。</p>
    } else {
      return <img className={classnames(styles.preview, 'cancel')} src={fileUrl} alt="プレビュー" width="100%" />
    }
  }

  return (
    <div className={styles.filePreview}>
      {mq.isPc ? (
        <>
          <ActionButton
            icon={open ? <Close size={14} /> : <Visibility className={styles.inheritMask} size={14} />}
            onClick={toggleOpen}
          >
            {open ? 'プレビューを閉じる' : 'プレビュー'}
          </ActionButton>
          {open && (
            <Rnd
              default={rndDefault}
              draggable={false}
              className={styles.draggable}
              minWidth="30%"
              minHeight={300}
              bounds="#root"
              cancel=".cancel"
            >
              <div className={styles.draggableInner}>
                <div className={styles.header}>
                  {'プレビュー'}
                  <ActionButton
                    className={classnames(styles.closeButton, 'cancel')}
                    icon={<Close size={20} />}
                    onClick={toggleOpen}
                  />
                </div>
                {renderPreview()}
              </div>
            </Rnd>
          )}
        </>
      ) : (
        <>{renderPreview()}</>
      )}
    </div>
  )
}
